import React, { useEffect, useState, Suspense, lazy, useMemo } from "react";
import "../../css/ViewList.scss";
import { DELETE_LIST, GET_allList } from "../../../services/constants";
import { useSelector } from "react-redux";
import axios from "axios";
import { Delete } from "@mui/icons-material";
import AreYousure from "../../share/card-layout/AreYousure";
import { Link } from "react-router-dom";
import AlertPopUp from "../../share/components/alert.component";
import { DottLoader } from "../../share/loader";
import backIcon from "../../Assets/common/back.svg";
import { FiKey } from "react-icons/fi";
import { CiCircleList } from "react-icons/ci";
import { useSearchParams } from "react-router-dom";
import FallbackLoader from "../../share/components/FallbackLoader";
import { ZustandStore } from "../../../store/zustand-store";
import { useTranslation } from "react-i18next";
import SemButton from "../../../common/components/Button";

const LazyKeywordsTable = lazy(() =>
  import("../../share/tables/KeywordsTable")
);

export const ViewList = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const list_type = searchParams.get("list_type");
  const email = useSelector((state) => state?.email);
  const { view_list } = ZustandStore((state) => state);
  const [SelectedList, setSelectedList] = useState("");
  const [Alert, setAlert] = useState({
    type: "",
    message: "",
    show: false,
  });
  // MODAL MUI FOR DELETE
  const [open, setOpen] = useState(false);
  const handleOpen = (name) => {
    setSelectedList(name);
    setOpen(true);
  };

  // Gte List
  const handleFetchListData = async () => {
    if (!email) return;
    try {
      const response = await axios.get(GET_allList(email));
      ZustandStore.setState({
        view_list: {
          data: response.data,
          loading: false,
        },
      });
    } catch {
      ZustandStore.setState({
        view_list: {
          data: [],
          loading: false,
        },
      });
    }
  };

  useEffect(() => {
    handleFetchListData();
  }, [email]);

  const viewListByType = useMemo(() => {
    return view_list?.data?.filter((item) => item.list_type === list_type);
  }, [view_list, list_type]);

  const viewSelectedList = useMemo(() => {
    return (
      viewListByType?.find((item) => item.list_name === SelectedList) || {
        keyword_list: [],
        list_name: SelectedList,
        list_type,
      }
    );
  }, [viewListByType, SelectedList, list_type]);

  const HandleDeleteList = async (RES) => {
    if (!RES) return setOpen(false);
    try {
      const response = await axios.delete(
        DELETE_LIST(email, SelectedList, list_type)
      );
      if (response?.data?.msg === "List Deleted Successfully") {
        setAlert({
          type: "success",
          message: "List deletion was successful.",
          show: true,
        });
      } else {
        setAlert({
          type: "error",
          message: "List deletion was unsuccessful.",
          show: true,
        });
      }
    } catch (error) {
      setAlert({
        type: "error",
        message:
          "Network error: Unable to delete the keyword. Please try again.",
        show: true,
      });
    } finally {
      setOpen(false);
      handleFetchListData();
    }
  };

  const handleSingleShow = (res) => {
    if (res?.keyword_list?.length === 0) {
      setAlert({
        type: "error",
        message: "List has no keywords",
        show: true,
      });
      return;
    }
    setSelectedList(res.list_name);
  };

  const KeywordHeader = useMemo(() => {
    if (list_type === "site") {
      return [
        {
          id: "keyword",
          sort: "keyword",
          key: "keyword",
          tooltip: t(
            "keyword_research.keyword_variations.table.keyword.tooltip"
          ),
          minWidth: "300px",
          label: t("keyword_research.keyword_variations.table.keyword.title"),
          align: "left",
          isTrending: false,
          isAiWriter: false,
          show: true,
          ignore: true,
        },

        {
          id: "AI",
          key: "AI",
          tooltip: t("keyword_research.keyword_variations.table.ai.tooltip"),
          minWidth: "130px",
          label: t("keyword_research.keyword_variations.table.ai.title"),
          align: "center",
          isTrending: false,
          isAiWriter: true,
          show: true,
          ignore: true,
        },
        {
          id: "search_volume",
          key: "volume",
          sort: "search_volume",
          tooltip: t(
            "keyword_research.keyword_variations.table.volume.tooltip"
          ),
          minWidth: "130px",
          tooltip: t(
            "keyword_research.keyword_variations.table.volume.tooltip"
          ),
          align: "center",
          isTrending: false,
          isAiWriter: false,
          show: true,
          ignore: true,
        },
        {
          id: "rank_group",
          key: "position",
          sort: "rank_group",
          tooltip: "The Position this keyword is ranked in Google search",
          minWidth: "130px",
          label: "Position",
          align: "center",
          isTrending: false,
          isAiWriter: false,
          show: true,
          ignore: true,
        },
      ];
    } else if (list_type === "qsb") {
      return [
        {
          id: "keyword",
          sort: "keyword",
          key: "keyword",
          tooltip: t(
            "keyword_research.keyword_variations.table.keyword.tooltip"
          ),
          minWidth: "300px",
          label: t("keyword_research.keyword_variations.table.keyword.title"),
          align: "left",
          isTrending: false,
          isAiWriter: false,
          show: true,
          ignore: true,
        },
        {
          id: "search_volume",
          key: "search_volume",
          sort: "search_volume",
          tooltip: t(
            "keyword_research.keyword_variations.table.volume.tooltip"
          ),
          minWidth: "250px",
          label: t("keyword_research.keyword_variations.table.volume.title"),
          align: "center",
          isTrending: false,
          isAiWriter: false,
          show: true,
          ignore: true,
        },
      ];
    } else {
      return [
        {
          id: "keyword",
          sort: "keyword",
          key: "keyword",
          tooltip: t(
            "keyword_research.keyword_variations.table.keyword.tooltip"
          ),
          minWidth: "300px",
          label: t("keyword_research.keyword_variations.table.keyword.title"),
          align: "left",
          isTrending: false,
          isAiWriter: false,
          show: true,
          ignore: true,
        },

        {
          id: "volume",
          key: "volume",
          sort: "volume",
          tooltip: t(
            "keyword_research.keyword_variations.table.volume.tooltip"
          ),
          minWidth: "110px",
          label: t("keyword_research.keyword_variations.table.volume.title"),
          align: "center",
          isTrending: true,
          isAiWriter: false,
          ignore: true,
          show: true,
        },
        {
          id: "avg_volume",
          key: "avg_volume",
          sort: "avg_volume",
          tooltip: t(
            "keyword_research.keyword_variations.table.avg_vol.tooltip"
          ),
          minWidth: "110px",
          label: t("keyword_research.keyword_variations.table.avg_vol.title"),
          align: "center",
          isTrending: true,
          isAiWriter: false,
          ignore: false,
          show: true,
        },
        {
          id: "vol_trend",
          key: "vol_trend",
          sort: "vol_trend",
          tooltip: t(
            "keyword_research.keyword_variations.table.vol_trend.tooltip"
          ),
          minWidth: "91px",
          label: t("keyword_research.keyword_variations.table.vol_trend.title"),
          align: "center",
          isTrending: true,
          isAiWriter: false,
          ignore: false,
          show: true,
        },
        {
          id: "cpc",
          key: "cpc",
          sort: "cpc",
          tooltip: t("keyword_research.keyword_variations.table.cpc.tooltip"),
          minWidth: "70px",
          label: t("keyword_research.keyword_variations.table.cpc.title"),
          align: "center",
          isTrending: true,
          isAiWriter: false,
          ignore: false,
          show: true,
        },
        {
          id: "search_intent",
          key: "search_intent",
          sort: "search_intent",
          tooltip: t(
            "keyword_research.keyword_variations.table.intent.tooltip"
          ),
          minWidth: "80px",
          label: t("keyword_research.keyword_variations.table.intent.title"),
          align: "center",
          isTrending: true,
          isAiWriter: false,
          ignore: false,
          show: true,
        },
        {
          id: "sd",
          key: "difficulty",
          sort: "sd",
          tooltip: t("keyword_research.keyword_variations.table.sd.tooltip"),
          minWidth: "70px",
          label: t("keyword_research.keyword_variations.table.sd.title"),
          align: "center",
          isTrending: true,
          isAiWriter: false,
          ignore: false,
          show: true,
        },
        {
          id: "backlinks",
          key: "avg_backlinks",
          sort: "backlinks",
          tooltip: t(
            "keyword_research.keyword_variations.table.avg_backlinks.tooltip"
          ),
          minWidth: "110px",
          label: t(
            "keyword_research.keyword_variations.table.avg_backlinks.title"
          ),
          align: "center",
          isTrending: true,
          isAiWriter: false,
          ignore: false,
          show: true,
        },
        {
          id: "reff_domains",
          key: "avg_reff_domains",
          sort: "reff_domains",
          tooltip: t(
            "keyword_research.keyword_variations.table.reff_domains.tooltip"
          ),
          minWidth: "100px",
          label: t(
            "keyword_research.keyword_variations.table.reff_domains.title"
          ),
          align: "center",
          isTrending: true,
          isAiWriter: false,
          ignore: false,
          show: true,
        },
        {
          id: "click",
          key: "avg_click",
          sort: "click",
          tooltip: t("keyword_research.keyword_variations.table.click.tooltip"),
          minWidth: "90px",
          label: t("keyword_research.keyword_variations.table.click.title"),
          align: "center",
          isTrending: true,
          isAiWriter: false,
          ignore: false,
          show: true,
        },
        {
          id: "impression",
          key: "avg_impression",
          sort: "impression",
          tooltip: t(
            "keyword_research.keyword_variations.table.impression.tooltip"
          ),
          minWidth: "120px",
          label: t(
            "keyword_research.keyword_variations.table.impression.title"
          ),
          align: "center",
          isTrending: true,
          isAiWriter: false,
          ignore: false,
          show: true,
        },
        {
          id: "AI",
          key: "AI",
          tooltip: t("keyword_research.keyword_variations.table.ai.tooltip"),
          minWidth: "55px",
          label: t("keyword_research.keyword_variations.table.ai.title"),
          align: "center",
          isTrending: false,
          isAiWriter: false,
          ignore: false,
          show: true,
        },
      ];
    }
  }, [list_type]);

  const keywordTableData = useMemo(() => {
    const keyMap = {
      volume: "search_volume",
      position: "rank_group",
    };

    const { list_type, list_name, keyword_list } = viewSelectedList;

    const handleTableDataKeyUpdate = (data = []) => {
      if (list_type !== "site") return data; // Return original data if list_type is not "site"

      return data?.map((item) =>
        Object.entries(item).reduce((acc, [key, value]) => {
          acc[keyMap[key] || key] = value; // Rename if key exists in keyMap, else keep original
          return acc;
        }, {})
      );
    };

    return {
      type: list_type,
      addToRankTracking: list_type !== "qsb",
      header_name: { title: list_name, show: false },
      header: KeywordHeader,
      row: handleTableDataKeyUpdate(keyword_list),
      config: {
        email: null,
        proj_name: null,
        tag_type: list_type,
        location_name: null,
        language_name: null,
      },
    };
  }, [viewSelectedList, KeywordHeader]);

  return (
    <div className="Domain_view main-pd">
      <AlertPopUp config={Alert} handleClose={setAlert} />
      {open && (
        <AreYousure
          callback={HandleDeleteList}
          title={"You will not able to recover this List !"}
        />
      )}
      {SelectedList ? (
        <>
          <div className="keyword_top_table_cont mt-0">
            <SemButton
              name={t("common_buttons.back")}
              title={t("common_buttons.back")}
              icon={<img src={backIcon} alt="back_btn" loading="lazy" />}
              onClick={() => {
                setSelectedList("");
              }}
              className="me-2"
            />

            <h6 className="keyword_top_table_title">
              {viewSelectedList.list_name}
            </h6>
          </div>

          <Suspense fallback={<FallbackLoader />}>
            <LazyKeywordsTable Data={keywordTableData} />
          </Suspense>
        </>
      ) : (
        <>
          <Link to={-1}>
            <button className="icon-btn large-btn">
              <img
                src={backIcon}
                alt="backIcon"
                className="me-1"
                loading="lazy"
              />
              {t("common_buttons.back")}
            </button>
          </Link>
          <div className="viewList">
            {view_list.loading ? (
              <DottLoader />
            ) : viewListByType.length > 0 ? (
              viewListByType?.map((val, index) => {
                return (
                  <div
                    className="ViewListBox"
                    key={`alllist-${index}`}
                    style={{ cursor: "default" }}
                  >
                    <div
                      className="d-flex justify-content-between point"
                      onClick={() => handleSingleShow(val)}
                    >
                      <div className="key-name font-bold ">
                        {val.list_name}{" "}
                        <p className="heading-small mb-0 font-medium"></p>
                      </div>
                      <div className="keyIcon">
                        <CiCircleList className="new-list-icon" />
                      </div>
                    </div>
                    <hr />
                    <div className="d-flex justify-content-between">
                      <div className="d-flex">
                        <div className="keyIconSub">
                          <FiKey
                            style={{
                              color: "#365486",
                              width: "25px",
                              height: "25px",
                            }}
                          />
                        </div>
                        <div className="descript ms-3">
                          {t("keyword_research.keyword_list.total_keyword")}{" "}
                          <strong>{val.keyword_list.length}</strong>
                        </div>
                      </div>
                      <div className="deleteBt">
                        <Delete
                          style={{ cursor: "pointer", color: "#365486" }}
                          onClick={() => {
                            handleOpen(val.list_name);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="EmptyBox">
                <h3 className="text-danger">
                  {t("keyword_research.keyword_list.no_list")}
                </h3>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};
